import { Outlet, useLocation } from 'react-router-dom';
import SideBarNavigation from './SideBarNavigation';
import Footer from '../footer/Footer';
import XQLogo from '../assets/eoaa-logo-horizontal-color.svg';
import UserProfile from './UserProfile';
import { useEffect, useMemo, useState } from 'react';
import CustomButton from '../reusable/CustomButton';
import ArrowFwdIcon from '../assets/nav-arrow-fwd.svg';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NAVIGATION_LINKS_DATA } from '../../constants';
import MainContentClassContext from '../../context/MainContentClassContext';

import './NavigationLayout.css';
import DistrictBar from './DistrictBar';

const NavigationLayout = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const isSelectDistrictPage = location.pathname === NAVIGATION_LINKS_DATA.SELECT_DISTRICT.path;
  const [isNavOpen, setIsNavOpen] = useState(isSmallScreen ? false : !isSelectDistrictPage);
  const [mainContentClass, setMainContentClass] = useState('');
  const mainContentClassValue = useMemo(() => ({ setClassName: setMainContentClass }), []);

  useEffect(() => {
    if (isSelectDistrictPage) {
      setIsNavOpen(false);
      return;
    }

    if (!isSmallScreen) {
      setIsNavOpen(true);
    }
  }, [isSelectDistrictPage, isSmallScreen]);

  return (
    <div className="App">
      <div className="top-bars-container">
        <div className="top-navigation">
          <div className="logo-container">
            <img src={XQLogo} alt="xq eduational outcomes audit and analysis" className="xq-logo"></img>
          </div>
          <UserProfile />
        </div>
        <DistrictBar />
      </div>
      <div data-testid="navigation-layouyt-main-container" className="layout-container">
        {isSmallScreen && (
          <div className="sidebar-overlay-open-button-container">
            <CustomButton variant="clear" buttonAction={() => setIsNavOpen(true)} sx={{ padding: '0', minWidth: '0' }}>
              <img alt="open/close navigation menu" src={ArrowFwdIcon} />
            </CustomButton>
          </div>
        )}
        <SideBarNavigation isOpen={isNavOpen} handleOpen={setIsNavOpen} />
        <MainContentClassContext.Provider value={mainContentClassValue}>
          <main className={`main-content-container ${mainContentClass}`.trim()}>
            <Outlet />
            <Footer />
          </main>
        </MainContentClassContext.Provider>
        <aside id="sideDrawer"></aside>
      </div>
    </div>
  );
};

export default NavigationLayout;
